<template>
  <div>
    <h1 class="center">AJUSTES</h1>
    <h3 class="center">Personalización</h3>
    <v-container style="">
      <div>
        <v-row>
          <v-col cols="12" lg="7" class="mr-5">
            <div style="width: 100%;">
              <table>
                <tr>
                  <td>TEXTO LOGO (CORTO)</td>
                  <td><input type="text" placeholder="ESCRIBIR" v-model="datosAjustes.textoLogoCorto" /></td>
                </tr>
                <tr>
                  <td>TEXTO LOGO (LARGO)</td>
                  <td><input type="text" placeholder="ESCRIBIR" v-model="datosAjustes.textoLogoLargo" />
                    <span>{{ indicaciones }}</span>
                  </td>

                </tr>
                <tr>
                  <td>TEXTO LOGO (SLOGAN)</td>
                  <td><input type="text" placeholder="ESCRIBIR" v-model="datosAjustes.textoLogoSlogan" />
                    <span>{{ indicaciones }}</span>
                  </td>
                </tr>
                <tr>
                  <td>TEXTO MOTIVACIÓN (LARGO)</td>
                  <td><input type="text" placeholder="ESCRIBIR" v-model="datosAjustes.textoMotivacion" />
                    <span>{{ indicaciones }}</span>
                  </td>
                </tr>

                <tr>
                  <td>COLOR TEXTO</td>
                  <td>
                    <div style="display: flex; gap: 20px;">
                      <div>TEXTO LOGO: <input type="color" v-model="datosAjustes.colorTextoLogo" /></div>
                      <div>TEXTO 1: <input type="color" v-model="datosAjustes.colorTexto1" /></div>
                      <div>TEXTO 2: <input type="color" v-model="datosAjustes.colorTexto2" /></div>
                    </div>
                  </td>

                </tr>
                <tr>
                  <td>COLOR PRINCIPAL/CABECERA Y PIE</td>
                  <td>
                    <div style="display: flex; gap: 20px;">
                      <div class="center">PRINCIPAL/CABECERA: <br><input style="width: 50px;" type="color"
                          v-model="datosAjustes.colorCabecera" /></div>
                      <div>PIE DE PAG: <br> <input style="width: 50px;" type="color" v-model="datosAjustes.colorPie" />
                      </div>
                    </div>
                  </td>

                </tr>
                <tr>
                  <td>COLOR FONDO</td>
                  <td>
                    <div style="display: flex; gap: 20px;">
                      <div>DEGRADADO: <br>
                        <h3><span class="pointer" :class="datosAjustes.colorDegradado == 0 ? 'line' : null"
                            style="border-radius: 5px; padding: 1px;"
                            @click="datosAjustes.colorDegradado = 0">0%</span>-<span class="pointer"
                            :class="datosAjustes.colorDegradado == 1 ? 'line' : null"
                            style="border-radius: 5px; padding: 1px;"
                            @click="datosAjustes.colorDegradado = 1">25%</span>-<span class="pointer"
                            :class="datosAjustes.colorDegradado == 2 ? 'line' : null"
                            style="border-radius: 5px; padding: 1px;"
                            @click="datosAjustes.colorDegradado = 2">50%</span>-<span class="pointer"
                            :class="datosAjustes.colorDegradado == 3 ? 'line' : null"
                            style="border-radius: 5px; padding: 1px;"
                            @click="datosAjustes.colorDegradado = 3">75%</span>
                        </h3>
                      </div>
                      <div>SUPERIOR: <input type="color" v-model="datosAjustes.colorSuperior" /></div>
                      <div>INFERIOR: <input type="color" v-model="datosAjustes.colorInferior" /></div>
                      <div>ELEMENTOS: <input type="color" v-model="datosAjustes.colorElemento" /></div>
                    </div>
                  </td>

                </tr>
                <tr>
                  <td>VIDEO</td>
                  <td>
                    <table style="border: none; border-collapse: collapse;">
                      <tr>
                        <td style="border: none; padding-right: 20px;">
                          VIDEO 1: <v-icon small class="line pointer"
                            style="padding: 1px; margin: 1px; border-radius: 10px;">
                            mdi-magnify
                          </v-icon> <input type="text" v-model="datosAjustes.enlaceVideo1" /><input class="mt-1"
                            type="checkbox" :checked="datosAjustes.videoUso == 1" @click="datosAjustes.videoUso = 1" />
                          USAR
                        </td>
                        <td style="border: none;">
                          VIDEO 2:
                          <v-icon small class="line pointer" style="padding: 1px; margin: 1px; border-radius: 10px;">
                            mdi-magnify
                          </v-icon>
                          <input type="text" v-model="datosAjustes.enlaceVideo2" /><input class="mt-1" type="checkbox"
                            :checked="datosAjustes.videoUso == 2" @click="datosAjustes.videoUso = 2" /> USAR
                        </td>
                      </tr>
                    </table>
                  </td>

                </tr>
                <tr>
                  <td>TEXTO PIE</td>
                  <td><input type="text" placeholder="ESCRIBIR" v-model="datosAjustes.textoPie" /></td>

                </tr>
                <tr>
                  <td>AUDIO</td>
                  <td>
                    <div style="display: flex; align-items: center;">
                      <input  type="checkbox" 
                      v-model="datosAjustes.audio"
                        />
                      <span class="pl-1">ACTIVAR AUDIO</span>
                    </div>
                  </td>

                </tr>
                <tr>
                  <td>CONTACTOS</td>
                  <td>
                    <v-icon class="ml-1" small>mdi-facebook</v-icon> FACEBOOK: <input type="text"
                      v-model="datosAjustes.linkFacebook" /><br />
                    <v-icon class="ml-1" small>mdi-instagram</v-icon>INSTAGRAM: <input type="text"
                      v-model="datosAjustes.linkInstagram" /><br />
                    <v-icon class="ml-1" small>mdi-youtube</v-icon>YOUTUBE: <input type="text"
                      v-model="datosAjustes.linkYoutube" /><br />
                    <v-icon class="ml-1" small>mdi-email</v-icon>EMAIL: <input type="email"
                      v-model="datosAjustes.linkEmail" /><br />
                    <v-icon class="ml-1" small>mdi-whatsapp</v-icon>WHATSAPP: <input type="text"
                      v-model="datosAjustes.linkWhatsapp" />
                  </td>

                </tr>
                <tr>
                  <td><v-btn color="#0000ff" dark class="center" @click="llenarDatosRecomendados()">
                      <h2>RECOMENDADO</h2>
                    </v-btn></td>
                  <td colspan="2"><v-btn color="#0000ff" dark class="center" @click="actualizarAjustes()">
                      <h2>GUARDAR TODO</h2>
                    </v-btn></td>
                </tr>
              </table>
            </div>
          </v-col>
          <v-col>
            <h3>VISTA PREVIA</h3>
            <div class="line" style="border-radius: 5px; width: 100%; overflow: hidden" :style="{
              background: `linear-gradient(to bottom, ${datosAjustes.colorSuperior} 10%, ${datosAjustes.colorInferior} ${datosAjustes.colorDegradado * 25}%, ${datosAjustes.colorInferior} 100%)`
            }">
              <div :style="{ backgroundColor: datosAjustes.colorCabecera }" style="height: 20px;">
                <h2 class="center" style="display: flex; color: aquamarine;">
                  <span class="ml-2" :style="{ color: datosAjustes.colorTextoLogo }">
                    <v-icon small :style="{ color: datosAjustes.colorTextoLogo }">mdi-menu</v-icon>
                    {{ datosAjustes.textoLogoCorto }}</span>
                  <v-spacer></v-spacer>
                  <span :style="{ color: datosAjustes.colorTexto1 }" class="mr-3"
                    style="text-align: right; font-size: xx-small;">
                    <v-icon :style="{ color: datosAjustes.colorTexto1 }" small>mdi-home</v-icon>
                    <span class="ml-1 mr-4">Oferta Academica</span> Matriculate</span>
                </h2>
              </div>
              <div style="background-color: #F2F2F280; height: 80px; width: 100%; align-content: center;">
                <h3 class="center">VIDEO</h3>
              </div>
              <h3 :style="{ color: datosAjustes.colorTexto2 }" class="pl-8 pr-8 pt-2 center" style="font-size: 5pt;"
                v-html="$textoFormateado($ajustes.textoMotivacion)"></h3>
              <v-row class="ma-0 mt-1">
                <v-col v-for="x in 4" class="pa-2" :key="'testdemo' & x" lg="3" cols="3">
                  <v-card :style="{ backgroundColor: datosAjustes.colorElemento }" style=" height: 80px;"></v-card>

                </v-col>
              </v-row>
              <br>
              <div :style="{ backgroundColor: datosAjustes.colorPie }">
                <h3 class="pt-2 center" :style="{ color: datosAjustes.colorTexto1 }">
                  <span class="ml-2">
                    {{ datosAjustes.textoPie }}</span>
                </h3>
                <div class="center">
                  <v-icon class="ml-1" dark small>mdi-facebook</v-icon>
                  <v-icon class="ml-1" dark small>mdi-instagram</v-icon>
                  <v-icon class="ml-1" dark small>mdi-email</v-icon>
                </div>
                <br>
              </div>
            </div>

          </v-col>
        </v-row>
      </div>
      <br>
    </v-container>
  </div>
</template>
<script>
import * as axios from "./axiosAjustes";
export default {
  components: {
  },
  data() {
    return {
      indicaciones: "Escriba entre: * * negrita; ~ ~ cursiva; _ _ subrayado; y \n para añadir un salto de linea",
      datosAjustes: {
        textoLogoCorto: "",
        textoLogoLargo: "",
        textoLogoSlogan: "",
        textoMotivacion: "",
        colorTextoLogo: "",
        colorTexto1: "",
        colorTexto2: "",
        colorCabecera: "",
        colorPie: "",
        colorDegradado: 0,
        colorSuperior: "",
        colorInferior: "",
        colorElemento: "",
        enlaceVideo1: "",
        enlaceVideo2: "",
        videoUso: 1,
        audio: 1,
        textoPie: "",
        linkFacebook: "",
        linkInstagram: "",
        linkYoutube: "",
        linkEmail: "",
        linkWhatsapp: "",
      },

      showMenu: true,
      show: {
        responsible: "",
      },

    };
  },
  mounted() {
    this.obtenerAjustes()
  },
  created() {
  },
  methods: {
    async obtenerAjustes() {
      var response = await axios.obtenerAjustes()
      var ajustes = response.data
      try {
        this.llenarDatos(ajustes)
      } catch (error) { null }
    },
    async actualizarAjustes() {
      var response = await axios.actualizarAjustes(this.datosAjustes)
      if (response) {
        alert("GUARDADO CON EXITO")
      }
    },
    llenarDatos(aux) {
      this.datosAjustes.textoLogoCorto = aux.textoLogoCorto;
      this.datosAjustes.textoLogoLargo = aux.textoLogoLargo;
      this.datosAjustes.textoLogoSlogan = aux.textoLogoSlogan;
      this.datosAjustes.textoMotivacion = aux.textoMotivacion;
      this.datosAjustes.colorTextoLogo = aux.colorTextoLogo;
      this.datosAjustes.colorTexto1 = aux.colorTexto1;
      this.datosAjustes.colorTexto2 = aux.colorTexto2;
      this.datosAjustes.colorCabecera = aux.colorCabecera;
      this.datosAjustes.colorPie = aux.colorPie;
      this.datosAjustes.colorDegradado = aux.colorDegradado;
      this.datosAjustes.colorSuperior = aux.colorSuperior;
      this.datosAjustes.colorInferior = aux.colorInferior;
      this.datosAjustes.colorElemento = aux.colorElemento;
      this.datosAjustes.enlaceVideo1 = aux.enlaceVideo1;
      this.datosAjustes.enlaceVideo2 = aux.enlaceVideo2;
      this.datosAjustes.videoUso = aux.videoUso;
      this.datosAjustes.audio = aux.audio;
      this.datosAjustes.textoPie = aux.textoPie;
      this.datosAjustes.linkFacebook = aux.linkFacebook;
      this.datosAjustes.linkInstagram = aux.linkInstagram;
      this.datosAjustes.linkYoutube = aux.linkYoutube;
      this.datosAjustes.linkEmail = aux.linkEmail;
      this.datosAjustes.linkWhatsapp = aux.linkWhatsapp;
    },
    llenarDatosRecomendados() {
      this.datosAjustes = this.$AjustesRecomendado()
    }
  },
  computed: {
  },
  beforeDestroy() {
  },
};
</script>

<style scoped>
.centered-input>>>input {
  text-align: center;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td {
  text-align: left;
  border: 1px solid #000;
  padding: 4px;
}

input[type="text"],
input[type="email"],
input[type="color"] {
  width: 95%;
  font-size: small;
  padding: 2px;
  box-sizing: border-box;
  border: #000 1px solid;
  border-radius: 3px;
}

button {
  width: 100%;
  padding: 10px;
  background-color: blue;
  color: white;

}
</style>